export const signInTypes = {
  EMAIL: 'email',
  PHONE_NUMBER: 'phone_number',
  IDENTITY_NUMBER: 'identity_number'
}
